<script>
export default {
  functional: true,
  name: 'InnerInput',
  render: function (h, { props, parent, children, listeners, ...args }) {
    const { name, value, showLabel } = props
    const change = listeners.change
    return (
      <div class={'sliderInput'}>
        {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
        <input onChange={change} value={value} class="scence_input" />
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
@import '~@/components/button/comps-button.scss';
.scence_input {
  width: 150px;
  height: 32px;
  line-height: 32px;
  outline: none;
  border: solid 1px #bdc5d3;
  border-radius: 4px;
  text-indent: 15px;
  color: #606266;
}
</style>
